import "./CommonErrorDialog.scss";

import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import React from "react";

export const CommonErrorDialog = ({
  error, setError
}: any) =>
  <Dialog
    className="error-dialog"
    open={error.length !== 0}
    onClose={() => setError("")}
    aria-labelledby="customized-dialog-title"
  >
    <DialogTitle className="title" id="alert-dialog-slide-title">
      {"Error"}
      <IconButton
        className="close-icon"
        aria-label="close"
        onClick={() => setError("")}
      >
        <CloseIcon />
      </IconButton>
    </DialogTitle>
    <DialogContent>
      <DialogContentText id="alert-dialog-slide-description">
        {error}
      </DialogContentText>
    </DialogContent>
  </Dialog>
;
